import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface TopRowProps {
    name: string
    quantity: number
    price: string
    compact: boolean
}

const TopRow: FC<TopRowProps> = ({ name, quantity, price, compact }) => {
    const { t } = useTranslation()
    const quantityLabel = `${quantity} ${t('common.overview.quantityUnit')}`

    return (
        <View style={styles.topRow}>
            {compact ? (
                <>
                    <Typography.Description size="normal" font="medium" style={styles.name}>
                        {name}
                    </Typography.Description>
                    <View
                        style={[styles.quantityAndPrice, compact && styles.quantityAndPriceCompact]}
                    >
                        <Typography.Description
                            size="normal"
                            font="medium"
                            style={styles.quantity}
                            numberOfLines={1}
                        >
                            {quantityLabel}
                        </Typography.Description>
                        <Typography.Description
                            size="normal"
                            font="medium"
                            style={styles.price}
                            numberOfLines={1}
                        >
                            {price}
                        </Typography.Description>
                    </View>
                </>
            ) : (
                <>
                    <Typography.Heading variant="h3" style={styles.name}>
                        {name}
                    </Typography.Heading>
                    <View
                        style={[styles.quantityAndPrice, compact && styles.quantityAndPriceCompact]}
                    >
                        <Typography.Heading variant="h4" style={styles.quantity} numberOfLines={1}>
                            {quantityLabel}
                        </Typography.Heading>
                        <Typography.Heading variant="h4" style={styles.price} numberOfLines={1}>
                            {price}
                        </Typography.Heading>
                    </View>
                </>
            )}
        </View>
    )
}

export default TopRow
